import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { RbacAccessResponse } from '../../../types/generated/rbacAccessResponse';

const RBAC_BASE_URL = `${environment.apiConfig.uri}/rbac`;

@Injectable({
  providedIn: 'root',
})
export class RbacService {
  private httpService = inject(HttpClient);

  getUserAccess() {
    return this.httpService.get<RbacAccessResponse>(RBAC_BASE_URL);
  }
}
